export default "__VITE_ASSET__DwZ9y6Ki__"